<template>
    <div class="wrapper">
        <div class="title_wrap">
            <p class="page_title">{{ title }}{{ title ? '-' : '' }}{{ $t('my.zuopinList') }}</p>
            <div class="btn_group">
                <el-button class="primary_btn" @click="back">{{ $t('my.back') }}</el-button>
                <el-button class="primary_btn" @click="navigateToCreateTouGao">
                    {{ $t('my.add') }}
                </el-button>
            </div>
        </div>
        <div class="filter_wrap">
            <primarySelect
                v-model="listQuery.status"
                :data="statusOptions"
                :placeholder="$t('my.statusPlhder')"
                clearable
            />
            <el-input
                v-model="listQuery.keyword"
                clearable
                style="width: 250px;"
                class="filter_item mr_10 ml_10"
                :placeholder="$t('my.keyPlhder')"
                @keyup.enter.native="handleFilter"
            />
            <el-button v-waves class="filter_btn" type="primary" @click="handleFilter">
                {{ $t('my.filter') }}
            </el-button>
        </div>
        <div v-loading="listLoading" class="list">
            <div class="theader">
                <p class="lis flex_1">{{ $t('my.num') }}</p>
                <p class="lis flex_2">{{ $t('my.zuopinName') }}</p>
                <p class="lis flex_1">{{ $t('my.zuopinCategory') }}</p>
                <p class="lis flex_1">{{ $t('my.ticket') }}</p>
                <p class="lis flex_2">{{ $t('my.submitTime') }}</p>
                <p class="lis flex_1">{{ $t('my.status') }}</p>
                <p class="lis flex_2 opera">{{ $t('my.operate') }}</p>
            </div>
            <div v-for="(item, index) in list" :key="index" class="theader tbody">
                <p class="lis flex_1">{{ index + 1 }}</p>
                <p class="lis flex_2">{{ item.title }}</p>
                <p class="lis flex_1">{{ item.category }}</p>
                <p class="lis flex_1">{{ item.ticket }}</p>
                <p class="lis flex_2">{{ item.updated_at }}</p>
                <p class="lis flex_1 status_actived">{{ item.status_name }}</p>
                <div class="lis flex_2 opera">
                    <el-button
                        v-if="!item.ticket"
                        :type="item.ticket ? 'info' : 'primary'"
                        size="default"
                        class="opera_tn"
                        :disabled="!!item.ticket"
                        @click="navigateToTouGao(item)"
                    >
                        {{ $t('my.edit') }}
                    </el-button>
                    <el-button
                        v-if="!item.ticket"
                        :type="item.ticket ? 'info' : 'primary'"
                        size="default"
                        class="opera_tn"
                        :disabled="!!item.ticket"
                        :loading="saveLoading"
                        @click="toPage('/confirm', item.id, '1')"
                    >
                        {{ $t('my.submit') }}
                    </el-button>
                    <el-button
                        v-if="item.ticket"
                        type="primary"
                        size="default"
                        class="opera_tn"
                        @click="toPage('/confirm', item.id, '0')"
                    >
                        {{ $t('my.view') }}
                    </el-button>
                    <!-- need_receipt && item.ticket && item.status >=2 -->
                    <el-button
                        v-if="item.status === 40 || item.status === 50 || item.status === 90"
                        type="primary"
                        size="default"
                        class="opera_tn"
                        @click="toPage('/confirm', item.id, '3')"
                    >
                        {{ $t('my.receipt') }}
                    </el-button>
                </div>
            </div>
        </div>
        <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            @pagination="getList"
        />
    </div>
</template>

<script>
import waves from '@/directive/waves'
import Pagination from '@/components/Pagination'
import primarySelect from '@/components/primarySelect'
import { mapGetters } from 'vuex'
import { zuopinList } from '@/api/Tougaos'
import { confirmZuopin } from '@/api/tougaosZuopins'

export default {
    name: 'ZuopinList',
    directives: { waves },
    components: { primarySelect, Pagination },
    props: {
        tid: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            statusOptions: [
                { key: 10, value: this.$t('my.enable') },
                { key: 20, value: this.$t('my.disabled') }
            ],
            saveLoading: false,
            listQuery: {
                tid: '',
                status: '',
                page: 1,
                limit: 15
            },
            listLoading: false,
            list: [],
            total: 0
        }
    },
    computed: {
        ...mapGetters(['tougaoSetting'])
    },

    created() {
        this.getList()
    },

    methods: {
        back() {
            // this.$router.go(-1)// 返回上一层
            this.$emit('close')
        },

        handleFilter() {
            this.list = []
            this.listQuery.tid = this.tid
            this.listQuery.page = 1
            this.getList()
        },

        getList() {
            this.listLoading = true
            this.listQuery.tid = this.tid
            zuopinList(this.listQuery)
                .then((res) => {
                    if (res.code === 200) {
                        this.list = res.data.list
                        this.listLoading = false
                    }
                })
                .catch(() => {
                    this.listLoading = false
                })
        },

        navigateToCreateTouGao() {
            console.log('this.tid', this.tid)
            this.$router.push({ path: '/tougao', query: { tid: this.tid } })
        },

        navigateToTouGao(item) {
            if (item.ticket) {
                this.$message({
                    message: '已确认状态,不可再编辑',
                    type: 'warning',
                    showClose: true,
                    duration: 2000
                })
                return
            }
            this.$router.push({
                path: '/tougao',
                query: { tid: this.tid, isEdit: 1, zuopin_id: item.id }
            })
        },

        toPage(url, id, type) {
            if (this.$route.path === url) return
            const { tid } = this
            const isNewPage =
                String(tid) === '29' ||
                String(tid) === '34' ||
                String(tid) === '50' ||
                String(tid) === '51'
            this.$router.push({
                path: isNewPage && type === '3' ? '/confirm_new' : url,
                query: { tid: this.tid, zuopin_id: id, issubmit: type }
            })
        },

        confirm() {
            this.$confirm('确认提交后不可再编辑, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.saveLoading = true
                    confirmZuopin({ id: this.zuopin_id }).then(() => {
                        this.$notify({
                            title: '成功',
                            message: '成功确认',
                            type: 'success',
                            duration: 2000
                        })
                        this.saveLoading = false
                        this.getList()
                    })
                })
                .catch(() => {
                    this.saveLoading = false
                })
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
@import '../../../styles/my';
@media screen and (max-width: 1260px) {
    .app-wrapper .whtie_wrap .left_content .title_wrap .page_title {
        font-size: 18px;
    }
    .app-wrapper .whtie_wrap .left_content .list .theader .opera .opera_tn {
        padding: 0 10px;
    }
}
</style>
